// The lobby's banner (art audit P5): the menu pool reused, wire only — it
// rotates with the party's size, so a filling lobby visibly fills in.

const LOBBY_HEROES = [
  '/assets/images/ui/menu_hero.webp',
  '/assets/images/ui/menu_hero_2.webp',
  '/assets/images/ui/menu_hero_3.webp',
  '/assets/images/ui/menu_hero_4.webp',
] as const;

export function LobbyHero({ partySize }: { readonly partySize: number }) {
  return (
    <img
      src={LOBBY_HEROES[partySize % LOBBY_HEROES.length]}
      alt="A hero's banner over the muster"
      className="h-24 w-full rounded-lg border border-amber-200/20 object-cover"
      data-testid="lobby-hero"
    />
  );
}
